import type { ThemeOptions } from '@mui/material';
import aclaraLogo from '../../assets/brandings/aclara/aclaraLogo.png';
import aclaraNavbarLogo from '../../assets/brandings/aclara/aclaraNavbarLogo.png';

export const aclaraTheme: ThemeOptions = {
  assets: {
    logoURL: aclaraLogo,
    navbarLogoURL: aclaraNavbarLogo,
  },
  palette: {
    primary: { main: '#6aa2ba' },
    secondary: { main: '#6aa2ba' },
    background: {
      default: '#fff',
      paper: '#fff',
    },
    appBarBackground: {
      main: '#6aa2ba',
      light: '#6aa2ba',
      dark: '#6aa2ba',
      contrastText: '#6aa2ba',
    },
    appBarText: { main: '#fff' },
  },
};
